export default "__VITE_ASSET__CYBhy1zc__"